import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Random Episode is:", -1)
const _hoisted_5 = { key: 1 }

import { useRoute } from 'vue-router';
import {
  computed,
  inject,
  onMounted,
  Ref,
  ref,
} from 'vue';
import { Episode, Show, TVMazeResponse } from '@/models/models';
import Loading from '@/views/Loading.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

const show = ref<Show>();
const episodes = ref<Episode[]>([]);
const result = ref<Episode>();
const shows = inject<Ref<TVMazeResponse[]>>('shows', ref([]));

onMounted(async () => {
  if (shows.value.length > 0) {
    [show.value] = shows.value
      .map((value) => value.show)
      .filter((inner) => inner.id === +route.params.id);
  } else {
    const response = await fetch(`https://api.tvmaze.com/shows/${route.params.id}`);
    show.value = await response.json();
  }
});
onMounted(async () => {
  const response = await fetch(`https://api.tvmaze.com/shows/${route.params.id}/episodes`);
  episodes.value = (await response.json() as Episode[])
    .filter((episode) => new Date(episode.airstamp) < new Date());
});

const randomize = () => {
  const randomIndex = Math.floor(Math.random() * episodes.value.length);
  result.value = episodes.value[randomIndex];
};

const isLoading = computed(() => !!show.value && episodes.value.length !== 0);

return (_ctx: any,_cache: any) => {
  return (_unref(isLoading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", null, _toDisplayString(show.value?.name), 1),
        _createElementVNode("p", {
          innerHTML: show.value?.summary
        }, null, 8, _hoisted_2),
        _createElementVNode("button", { onClick: randomize }, "Randomize"),
        (result.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("p", null, [
                _createElementVNode("b", null, _toDisplayString(result.value?.name), 1)
              ]),
              _createElementVNode("p", null, "Season: " + _toDisplayString(result.value?.season), 1),
              _createElementVNode("p", null, "Episode: " + _toDisplayString(result.value?.number), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createVNode(Loading)
      ]))
}
}

})